import { lazy } from 'react';

import { BrowserRouter, Route, Routes as Switch } from 'react-router-dom';

import PageLoadable from 'src/components/PageLoadable';

const Home = PageLoadable(lazy(() => import('src/pages/Home')));
const Exames = PageLoadable(lazy(() => import('src/pages/Exames')));
const Laudos = PageLoadable(lazy(() => import('src/pages/Laudos')));
const Private = PageLoadable(lazy(() => import('src/pages/Private')));
const Paciente = PageLoadable(lazy(() => import('src/pages/Paciente')));
const LoginPage = PageLoadable(lazy(() => import('src/pages/LoginPage')));
const Convenios = PageLoadable(lazy(() => import('src/pages/Convenios')));
const EsqueciSenha = PageLoadable(lazy(() => import('src/pages/EsqueciSenha')));
const LoginPageSite = PageLoadable(lazy(() => import('src/pages/LoginPageSite')));
const UnidadesColeta = PageLoadable(lazy(() => import('src/pages/UnidadesColeta')));
const NotFound404 = PageLoadable(lazy(() => import('src/pages/Errors/NotFound404')));

const MasterPageLab = PageLoadable(lazy(() => import('src/components/MasterPageLab')));
const MasterPageResultados = PageLoadable(lazy(
  () => import('src/components/MasterPageResultados'),
));

const AuthProvider = PageLoadable(lazy(() => import('src/Context/AuthContext').then((module) => ({
  default: module.AuthProvider,
}))));
const ConfigProvider = PageLoadable(lazy(() => import('src/Context/ConfigContext').then((module) => ({
  default: module.ConfigProvider,
}))));

export function Router() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_ROUTE}>
      <AuthProvider>
        <ConfigProvider>
          <Switch>
            {/* Páginas referentes a resultados dos exames Online */}
            <Route path="/default" element={<LoginPage />} />
            <Route path="/default.aspx" element={<LoginPage />} />
            <Route path="/acao.aspx" element={<LoginPage />} />
            <Route path="/esqueciasenha" element={<EsqueciSenha />} />
            <Route path="/Laudos/:id/" element={<Laudos />} />
            <Route path="/Laudos/:id/:id2" element={<Laudos />} />
            {process.env.REACT_APP_POSSUI_SITE === 'false' ? (
              <Route
                path="/"
                element={(
                  <Private>
                    <MasterPageResultados />
                  </Private>
                      )}
              >
                <Route path="" element={<Home />} />
              </Route>
            ) : (
              <>
                <Route path="/" element={<MasterPageLab />}>
                  <Route path="" element={<LoginPageSite />} />
                  <Route path="exames" element={<Exames />} />
                  <Route path="unidades" element={<UnidadesColeta />} />
                  <Route path="convenios" element={<Convenios />} />
                </Route>
                <Route
                  path="/resultados"
                  element={(
                    <Private>
                      <MasterPageResultados />
                    </Private>
                        )}
                >
                  <Route path="" element={<Home />} />
                </Route>
              </>
            )}
            {process.env.REACT_APP_TELA_PACIENTES === 'true' && (
              <Route path="paciente" element={<Private><MasterPageResultados /></Private>}>
                <Route path="" element={<Paciente />} />
              </Route>
            )}
            <Route path="*" element={<NotFound404 />} />
          </Switch>
        </ConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
